<template>
  <div class="text-center">
    <form class="form-signin" @submit.prevent>
      <h1 class="h3 mb-3 font-weight-normal">Dodaj pracownika</h1>
      <input class="form-control inputTop" v-model.trim="signupForm.name" type="text" placeholder="Imie" />

      <input
        class="form-control inputCenter"
        v-model.trim="signupForm.title"
        type="text"
        placeholder="Nazwisko"
      />

      <input class="form-control inputCenter" v-model.trim="signupForm.email" type="text" placeholder="Email" />

      <input
        class="form-control inputBottom"
        v-model.trim="signupForm.password"
        type="password"
        placeholder="Hasło"
      />
      <hr>
      <h1 class="h3 mb-3 font-weight-normal">Dodatkowe informacje</h1>
       <input class="form-control inputTop" v-model.trim="signupForm.companyEmail" type="text" placeholder="Firmowy Email" />
        <input class="form-control inputCenter" v-model.trim="signupForm.phoneOne" type="text" placeholder="Pierwszy numer telefonu" />
           <input class="form-control inputCenter" v-model.trim="signupForm.phoneTwo" type="text" placeholder="Drugi numer telefonu" />
              <input class="form-control inputBottom" v-model.trim="signupForm.companyAddress" type="text" placeholder="Adres firmy" />
      <button @click="signup()" class="btn btn-lg btn-success btn-block mt-2">
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          class="bi bi-person-plus"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M11 14s1 0 1-1-1-4-6-4-6 3-6 4 1 1 1 1h10zm-9.995-.944v-.002.002zM1.022 13h9.956a.274.274 0 0 0 .014-.002l.008-.002c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664a1.05 1.05 0 0 0 .022.004zm9.974.056v-.002.002zM6 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm4.5 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
          />
          <path
            fill-rule="evenodd"
            d="M13 7.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0v-2z"
          />
        </svg>
      </button>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      signupForm: {
        name: "",
        title: "",
        email: "",
        password: "",
        companyEmail: "",
        phoneOne: "",
        phoneTwo: "",
        companyAddress: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
    };
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    tooglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login() {
      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });
    },
    signup() {
      this.$store.dispatch("signup", {
        email: this.signupForm.email,
        password: this.signupForm.password,
        name: this.signupForm.name,
        title: this.signupForm.title,
        companyEmail: this.signupForm.companyEmail,
        phoneOne: this.signupForm.phoneOne,
        phoneTwo: this.signupForm.phoneTwo,
        companyAddress: this.signupForm.companyAddress,
      });
    },
  },
};
</script>
<style scoped>
.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.inputTop {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-top: 10px;
  margin-bottom: 2px;
}
.inputCenter {
    border-radius: 0;
    margin-bottom: 2px;
}
.inputBottom {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-bottom: 10px;
}
</style>